<template>
    <div>
        <div class="content border radius-10 mb-50">
            <el-row>
                <el-col :span="24">
                    <div class="bg-gary p-10 skillListTitle">
                        <h2>Extended Project Qualification</h2>
                        <a :href="require('../../assets/epq_forms1-13.docx')">
                            <el-button type="success"><i class="icon ion-android-download"></i> EPQ offline document</el-button>
                        </a>
                    </div>
                </el-col>
            </el-row>
            <div v-loading="loading" :element-loading-text="loadingText">
                <!--技能列表-->
                <el-row class="border-b-2 p-20 ml-none mr-none" :gutter="20" v-for="skill in report.skillList" :key="skill.id"  v-if="skill.pageList.length !== 0 && (skill.name !== 'Form 12' && skill.name !== 'Form 10')">
                    <el-col :span="6" class="mt-10 mb-20">
                        <div>
                            <h2 class="mb-2">{{skill.name}}</h2>
                            <!--<el-button type="success" class="mr-5 mb-5 p-5" size="mini" v-on:click="showPageDialog(skill, skill.pageList[0])"><i-->
                                    <!--class="icon ion-ios-book"></i> Portfolio-->
                            <!--</el-button>-->
                            <!--<router-link class="white"-->
                                         <!--:to="{ path: 'evidence', query: { studentId: studentId, skillId: skill.id, skillAbbr: skill.abbr, skillName: skill.name, reportId:report.id,reportName: report.category, reportIndex: $route.path }}"-->
                                         <!--append>-->
                                <!--<el-button type="primary" class="ml-none p-5" size="mini">-->
                                    <!--<i class="icon ion-folder"></i> Evidence-->
                                <!--</el-button>-->
                            <!--</router-link>-->

                        </div>
                    </el-col>
                    <el-col :span="18" class="line-right">
                        <div class="el-col-8" v-for="page in skill.pageList" :key="page.id">
                            <div class="border-b" v-if="skill.name !== 'Form 13'">
                                <el-button type="text" class="" @click="showPageDialog (skill, page)">{{page.page}}</el-button>
                            </div>
                            <!--
                            <el-tooltip class="" effect="dark" v-bind:content="page.confirmed?'Confirmed by tutor':'Unconfirmed by tutor'" placement="bottom">
                                <i v-bind:class="page.confirmed?'el-icon-check mt-10 success':'el-icon-close mt-10 dark'" style="font-size: 22px; font-weight: bold;"></i>
                            </el-tooltip>
                            -->
                            <router-link class="white mt-20" style="display: inline-block;vertical-align: super;"
                            :to="{ path: 'evidence', query: { studentId: studentId, pageId: page.id, skillAbbr: skill.abbr, skillName: skill.name, pageName: page.page, reportId:report.id,reportName: report.category, reportIndex: $route.path }}"
                            append>
                                <el-tooltip class="" effect="dark" content="Evidence" placement="top">
<!--                                    <i class="icon ion-folder primary ml-10" style="font-size: 22px; font-weight: bold;"></i>-->
                                    <el-button v-if="category==='epq' && page.showUpload == true" type="primary"  size="mini" plain>{{skill.name == 'Form 11' ? 'Result Download' : 'Submission Entry'}}<i class="icon ion-folder ml-10"></i></el-button>
                                </el-tooltip>
                            </router-link>

                        </div>
                    </el-col>
                </el-row>

                <!--<el-row type="flex" class="mb-30 mt-30" justify="center">
                    <el-button type="primary" class="mr-10" :loading="generateReportLoading" @click="downloadReport"><i class="icon ion-shuffle"></i>
                        Generate Report
                    </el-button>
                </el-row>-->

            </div>

            <skill-dialog :report="report" ref="reportDialog"></skill-dialog>
            <a id="generate-link"></a>

        </div>

    </div>

</template>

<script>
    import Cookies from 'js-cookie'
    import SkillDialog from '../common/ReportDialog.vue'
    import axios from 'axios'

    export default {

        components: {
            'skill-dialog': SkillDialog
        },

        data() {
            return {
                report: {},
                studentId: 0,
                userId: 0,
                role: 'student',
                displayName: '',
                displayName2: '',
                category: 'cope',
                active: 0,
                loading: false,
                loadingText: 'loading...',
                generateReportLoading: false,
                progressActiveIndex: 0,

                //aope技能顺序
                aopeItems: ['TW','PRL','TP', 'RS', 'ISP','LWE','CE'],

            }
        },
        methods: {

            showPageDialog: function (skill, page) {
                this.$refs.reportDialog.showDialogFromStu(this.report, skill, page.page, page.id, this.displayName);
            },

            clone: function (myObj) {
                if (typeof(myObj) != 'object') return myObj;
                if (myObj == null) return myObj;
                var myNewObj = new Object();
                for (var i in myObj)
                    myNewObj[i] = this.clone(myObj[i]);
                return myNewObj;
            },
            next() {
                if (this.active++ > 2) this.active = 0;
            },

            saveAlert: function (done) {
                if (this.isDirty) {
                    this.$confirm('Confirm to leave the page without saving?', 'Warning', {
                        confirmButtonText: 'Leave',
                        cancelButtonText: 'Cancel',
                        type: 'warning'
                    }).then(_ => {
                        this.isDirty = false;
                        done();
                    }).catch(_ => {
                    });
                } else {
                    this.isDirty = false;
                    done();
                }
            },

            getCurrentPageIndex: function (skill, page) {
                for (var i = 0; i < skill.pageList.length; i++) {
                    if (skill.pageList[i].page == page) return i;
                }
            },

            downloadFile(blob, fileName, aLinkId) {
                // 能力检测
                // IE独家秘笈 => navigator.msSaveBlob
                if(window.navigator.msSaveBlob){
                    // for ie 10 and later
                    try {
                        window.navigator.msSaveBlob(blob, fileName);
                    } catch(e) {
                        console.log(e);
                    }
                } else {
                    try {
                        let aLink = document.getElementById(aLinkId);
                        aLink.download = fileName;
                        aLink.href = window.URL.createObjectURL(blob);
                        aLink.click();
                        window.URL.revokeObjectURL(blob);
                    } catch(e) {
                        console.log(e);
                    }
                }
            },

            downloadReport: function (event) {
                this.loading = true;
                let category = this.category === 'cope' ? 'CoPE' : (this.category === 'aope' ? 'AoPE' : ''),
                    fileName =  this.displayName2 +'_'+ category +'.pdf',
                    aLinkId = 'generate-link';
                this.loadingText = 'Generating, please wait...';
                axios.instance().get('report/download',{params:{studentId: this.studentId, category:this.category},responseType:'blob'}).then(response =>{
                    let blob = response.data;
                    this.downloadFile(blob, fileName, aLinkId)
                    this.loading = false;
                    this.loadingText = 'loading...';
                }).catch(error =>{
                    console.log(error)
                    this.loading = false;
                    this.loadingText = 'loading...';
                    this.$message.error('Service unavailable, please try again later.');
                });
            },

            // 将aope数据排序
            customSort(list, items) {
                var newSkillList = [];
                list.forEach(value => {
                    var abbr = value['abbr'];
                    items.forEach((item, itemIndex) => {
                        abbr === item ? newSkillList[itemIndex] = value : '';
                    })
                })
                return newSkillList;
            },

            getReport: function () {
                this.loading = true;
                var _this = this;
                this.requestApi('report?studentId=' + this.studentId + '&category=' + this.category, 'get', {}, function (response) {
                    if(_this.category =='aope'){
                        response.skillList = _this.customSort(response.skillList, _this.aopeItems);
                    }
                    _this.report = response;
                    _this.loading = false;
                }, function () {
                    _this.loading = false;
                })
            },
            more: function (obj) {
                var newObj = this.clone(obj[obj.length - 1]);
                for (var config in newObj) {
                    newObj[config].answer = '';
                }
                obj.push(newObj);
                this.isDirty = true;
            },
            less: function (obj) {
                this.$confirm('Confirm to delete the answer?', 'Warning', {
                    confirmButtonText: 'Delete',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    var msg = '';
                    var type = '';
                    if (obj.length > 1) {
                        obj.pop();
                        msg = 'success';
                        type = 'success';
                    } else {
                        msg = 'You can\'t delete when there\'s only one answer';
                        type = 'error';
                    }
                    this.$message({
                        type: type,
                        message: msg
                    });
                });
                this.isDirty = true;
            },

            showNextPage: function (skill, page, pageId) {
                if (this.isDirty) {
                    this.$confirm('Confirm to go to other page without saving?', 'Warning', {
                        confirmButtonText: 'Go',
                        cancelButtonText: 'Cancel',
                        type: 'warning'
                    }).then(_ => {
                        this.showPage(skill, page, pageId);
                        this.isDirty = false;
                    }).catch(_ => {
                    });
                } else {
                    this.showPage(skill, page, pageId);
                    this.isDirty = false;
                }
            },

            //请求获取指定page的所有问题的评论(按问题顺序排列的二维数组)
            getComment: function (pageId) {
                var _this = this;
                this.requestApi('comment/page?studentId=' + this.studentId + '&pageId=' + pageId, 'get', {}, function (response) {
                    _this.comments = response
                });
            },

            //将数据渲染到模态框中
            handleQuestionList: function (list) {
                var count = 0;
                for (var i = 0; i < list.length; i++) {
                    var group = [];
                    for (var j = 0; j < list[i].length; j++) {
                        list[i][j].show = false;
                        //绑定comment
                        list[i][j].content = '';
                        list[i][j].isDisabled = false;
                        list[i][j].showCommentCount = this.showCommentCount;
                        list[i][j].commentList = this.comments[count];
                        list[i][j].config = JSON.parse(list[i][j].config);
                        group.push(list[i][j]);
                        count++;
                    }
                    this.questions.push(group);

                }
                this.isDialogLoading = false
            },

            //获取指定page的问题，当前page没有回答时请求加载
            getQuesion: function (pageId) {
                var _this = this;
                this.requestApi('question/' + pageId, 'get', {}, function (response) {
                    _this.handleQuestionList(response);
                });
            },

            //请求当前page答案
            getAnswer: function (pageId) {
                var _this = this;
                this.requestApi('report/answer?reportId=' + this.report.id + '&pageId=' + pageId, 'get', {}, function (response) {
                    _this.getComment(pageId);
                    //存在则显示，不存在则请求question
                    if (response.questionList.length == 0) {
                        _this.getQuesion(pageId);
                    } else {
                        _this.handleQuestionList(response.questionList);
                    }
                });
            },

            //通过此函数获得请求并显示dialog所需的所有数据
            getDialogAll: function (pageId) {
                //请求当前page评论
                var _this = this;
                this.requestApi('comment/page?studentId=' + this.studentId + '&pageId=' + pageId, 'get', {}, function (response) {
                    _this.comments = response;
                    _this.getAnswer(pageId)
                });
            },

            closeDialog: function () {
                window.onbeforeunload = null;
                window.onunload = null;
            },

            //处理显示当前page的所有逻辑
            showPage: function (skill, page, pageId) {
                if (page == '' || page == undefined) return;
                this.currentSkill = skill;
                this.currentPage = page;
                //清空this.questions,
                this.questions.splice(0, this.questions.length);
                this.getDialogAll(pageId);
                this.progressActiveIndex = this.getCurrentPageIndex(skill, page);
                this.isDialogLoading = true
                this.skilldialog = true;
                for (var i = 0; i < skill.pageList.length; i++) {
                    var pageObj = skill.pageList[i];
                    if (pageObj.page == page) {
                        if (i == (skill.pageList.length - 1)) {
                            this.nextPage = '';
                        } else {
                            this.nextPage = {page: skill.pageList[i + 1].page, id: skill.pageList[i + 1].id};
                        }
                    }
                }

                window.onbeforeunload = function () {
                    return "quit?";
                }

                window.onunload = function () {
                    return "reload?";
                }
            },

            //提交评论
            saveComment: function (question, commentList) {
                if (question.content == null || question.content == '' || (question.content != null && question.content.trim().length == 0)) {
                    this.$message.error('Comment cant\'t be empty');
                    return;
                }
                question.isDisabled = true;
                var _this = this;
                this.$http.post('comment', {studentId: this.studentId, questionId: question.id, content: question.content}).then(response => {
                    commentList.push(response);
                    this.$message({message: 'Your comment is successfully posted.', type: 'success'});
                    question.content = '';
                    question.isDisabled = false;

                }).catch(error => {
                    this.$message.error(error.message);
                    question.isDisabled = false;
                })
            },

            //删除评论
            cancelComment: function (comment, commentList) {
                this.$http.delete('comment/' + comment.id).then(response => {
                    commentList.splice(commentList.indexOf(comment), 1)
                    this.$message.success('Success')
                }).catch(error => {
                    this.$message.error(error.message)
                })
            },

            saveAnswer: function () {
                if (!this.isDirty) {
                    this.$message({
                        type: 'warning',
                        message: 'Portfolio hasn\'t been edited'
                    });
                    return;
                }
                var postQuestionList = [];
                var _this = this;
                this.saving = true;
                this.questions.forEach(function (group) {
                    group.forEach(function (question) {
                        var answer = {
                            id: question.answerId,
                            report: {id: _this.report.id},
                            question: {id: question.id},
                            answer: JSON.stringify(question.config)
                        }
                        postQuestionList.push(answer);
                    });
                });
                var _this = this;
                this.$http.post('report/answer', postQuestionList).then(response => {
                    var count = 0;
                    for (var i = 0; i < _this.questions.length; i++) {
                        var group = _this.questions[i];
                        for (var j = 0; j < group.length; j++) {
                            group[j].answerId = response[count];
                            count++;
                        }
                    }
                    this.$message({message: 'Portfolio saved successfully.', type: 'success'});
                    this.saving = false;
                }).catch(error => {
                    this.saving = false;
                    this.$message.error(error.message)
                })
                this.isDirty = false;
            },

            requestApi: function (url, method, params, successFunc) {
                this.$http({
                    method: method,
                    url: url,
                    data: params
                }).then(response => {
                    successFunc(response);
                }).catch(error => {
                    this.isDialogLoading = false
                    this.$message.error(error.message)
                })
            },
            init: function () {
                this.role = Cookies.get('role');
                this.userId = Cookies.get('userid');
//                this.displayName = decodeURI(Cookies.get('name'));
                if (this.role == 'student') {
                    this.studentId = Cookies.get('studentId');
                }
                this.category = this.$route.name.toLowerCase();
                this.getReport();
            },

            //获取学生个人信息（拼音）
            getProfile(){
                this.$http.get('student/' + this.studentId).then(response => {
                    this.displayName = response.displayName + ' - ' + response.givenName + '  ' +  response.familyName;
                    this.displayName2 = response.displayName +'_'+ response.givenName +'_'+ response.familyName;
                    var tipsMsg = ''
                    if(response.tips && response.tips !== null){
                        tipsMsg = response.tips
                    }else{
                        tipsMsg = ''
                    }
                    this.$emit('setTips', tipsMsg);
                }).catch(error => {
                    this.$message.error(error.message)
                })
            }
        },
        mounted: function () {
            this.$nextTick(function () {
                this.init();
                this.getProfile();
            })
        },

        watch: {
            // 如果路由有变化，会再次执行该方法
            '$route': 'init',
                
        }
    };
</script>

<style lang="scss" scoped>

    @import "../../css/variable";

    .radius-10 {
        border-radius: 10px;
    }

    .content {
        .border-b {
            border-bottom: 1px solid $header-color;
        }
        .border-b-2 {
            border-bottom: 2px solid $header-color;
        }
        .skillListTitle {
            height: 36px;
            background: $header-color;
            border-top-left-radius: 9px;
            border-top-right-radius: 9px;
            h2 {
                display: block;
                float: left;
                margin-top: 7px !important;
            }
            button {
                float: right;
                margin-left: 5px;
            }
        }
        .line-right {
            button {
                display: inline-flex;
                width: 100%;
            }
            i:hover {
                color: $primary;
            }
        }
    }

    @-moz-document url-prefix() {
        .line-right button {
            text-align: left; //火狐下button文字居中对齐改为居左
        }
    }

    .question-title {
        display: table;
    }

    .owner {
        position: absolute;
        top: -68px;
        right: 40px;
    }


</style>


// WEBPACK FOOTER //
// Report.vue?cfeea2ae